import React from 'react';
import { MapPin, CheckCircle2 } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const ServiceAreas = () => {
  const areas = [
    'Goole',
    'Howden',
    'Thorne',
    'Selby',
    'York',
    'Surrounding Areas'
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <Card className="border-2 border-green-600 shadow-2xl overflow-hidden">
            <div className="bg-gradient-to-r from-green-600 to-green-700 text-white p-8 md:p-12 relative">
              {/* Logo watermark */}
              <div className="absolute top-4 right-4 opacity-10">
                <img 
                  src="https://customer-assets.emergentagent.com/job_6ff89c30-29b2-4ef0-998b-b868478450b8/artifacts/blcaejru_WhatsApp%20Image%202026-02-08%20at%2018.37.39.jpeg"
                  alt="MS Building Contractors"
                  className="w-32 h-32 object-contain"
                />
              </div>
              <div className="flex items-center justify-center mb-6">
                <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                  <MapPin className="w-8 h-8" />
                </div>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
                Areas We Cover
              </h2>
              <p className="text-xl text-green-50 text-center max-w-2xl mx-auto">
                Proudly serving customers across East Yorkshire and surrounding areas
              </p>
            </div>

            <CardContent className="p-8 md:p-12">
              <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
                {areas.map((area, index) => (
                  <div 
                    key={index}
                    className="flex items-center space-x-3 p-4 bg-gray-50 rounded-lg hover:bg-green-50 hover:border-green-200 border-2 border-transparent transition-all duration-300"
                  >
                    <CheckCircle2 className="w-6 h-6 text-green-600 flex-shrink-0" />
                    <span className="font-semibold text-gray-900">{area}</span>
                  </div>
                ))}
              </div>

              <div className="mt-10 text-center">
                <p className="text-gray-600 mb-6 text-lg">
                  Not sure if we cover your area? Get in touch and we'll be happy to help!
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <a 
                    href="tel:07398238042"
                    className="inline-flex items-center justify-center bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-3 rounded-lg transition-colors"
                  >
                    <MapPin className="w-5 h-5 mr-2" />
                    Call Martyn: 07398 238042
                  </a>
                  <a 
                    href="tel:07512760062"
                    className="inline-flex items-center justify-center bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-3 rounded-lg transition-colors"
                  >
                    <MapPin className="w-5 h-5 mr-2" />
                    Call Jake: 07512 760062
                  </a>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
